import styled from "styled-components";

const StyledButton = styled.button`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  height: 60px;
  border: 0;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.14);
  border-radius: 100px;
  font-weight: bold;
  font-size: 14px;
  padding: 0 40px;
  outline: 0;
  cursor: pointer;
  color: ${props => props.theme.palette.primary};
  font-family: ${props => props.theme.typo.fontFamily};

  @media (min-width: 768px) {
    font-size: 18px;
    height: 80px;
    padding: 0 60px;
  }
`;

export default StyledButton;
